import Image from "next/image";
import Link from "next/link";
import { useContext, useState, useEffect } from "react";
import { useRouter } from 'next/router'; 
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from "swiper/core";
import { BsFillBagHeartFill } from "react-icons/bs";
import { Snackbar } from './Snackbar';
import SignIn from "../../pages/auth/SignIn"
import Modal from 'react-modal';
import {
  FaShoppingCart,
  FaPlus,
  FaArrowRight,
  FaHeartBroken,
  FaMinus,
  FaArrowLeft,
  FaHeart,
  FaRegHeart,
  FaInfoCircle,
} from "react-icons/fa";
import { BiHeart } from "react-icons/bi";
import { CurrencyContext } from "../../contexts/CurrencyContext";
import { CartContext } from "../../contexts/CartContext";
import { UserContext } from '../../contexts/UserContext';
import { WishlistContext } from "../../contexts/WishlistContext";
import "swiper/swiper.min.css";
import Skeleton from "react-loading-skeleton";
import { setImageSrc } from '../../utils/config';

SwiperCore.use([Navigation]);
// Slider components for Home page
function ProductsSlider({ products, isLoading }) {
  const router = useRouter(); // Initialize the useRouter hook
  // State for cart,wishlist,snackbar
  const { token,userDetails } = useContext(UserContext);
  const { formatCurrency } = useContext(CurrencyContext);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarProduct, setSnackbarProduct] = useState(null);
  const { cart, addToCart, updateQuantity } = useContext(CartContext);
  const { wishlist, addToWishlist, removeFromWishlist } =
    useContext(WishlistContext);

const [wishlistStatus, setWishlistStatus] = useState(
  products?.reduce(
    (acc, product) => ({ ...acc, [product.id]: "not_added" }),
    {}
  ) || {} // Default to an empty object if products is undefined
);

  const [isRemoved, setIsRemoved] = useState(false);
  const isWishlisted = (product) => {
    if (!product || !wishlistStatus) return false; // Make sure both product and wishlistStatus are available
    return wishlistStatus[product.id] !== "not_added";
};




// Toggle wishlist status
// Toggle wishlist status
const toggleWishlist = async (product) => {
  if (token === "null") {
    router.push('/auth/SignIn'); // Navigate to the SignIn page
  } else {
    // Use product.product_id instead of product.id
    if (wishlistStatus[product.product_id] === "added") {
      await removeFromWishlist(product);
      setWishlistStatus({ ...wishlistStatus, [product.product_id]: "removed" });
    } else {
      await addToWishlist(product);
      setWishlistStatus({ ...wishlistStatus, [product.product_id]: "added" });
    }
  }
};

  const [quantity, setQuantity] = useState(
    products?.reduce((acc, product) => ({ ...acc, [product.id]: 1 }), {})
  );
    // Update wishlist status based on wishlist data
 // Update wishlist status based on wishlist data
useEffect(() => {
  const newWishlistStatus = products?.reduce((acc, product) => {
    const wishlistItem = wishlist?.find(
      (item) => item.product_id === product.product_id // Use product.product_id
    );
    if (wishlistItem) {
      return { ...acc, [product.product_id]: "added" }; // Use product.product_id
    }
    return { ...acc, [product.product_id]: "not_added" }; // Use product.product_id
  }, {});

  setWishlistStatus(newWishlistStatus);
}, [products, wishlist]);

  
// for add to cart
  const handleAddToCart = (product) => {

    if (token == "null") {
        router.push('/auth/SignIn'); // navigate to auth/SignIn page
    } else {
        const transformedProduct = {
            categoryName: product.category_name, // Assuming this field exists in your product data
            image: product.image_url, // Directly using image_url
            name: product.product_name, // Using product_name
            id: product.product_id, // Using product_id
            price: product.price, // Assuming price is directly usable
            productCount: 1, // Assuming a default count of 1
            // Include any other fields as needed
        };

        addToCart(transformedProduct);
        setSnackbarProduct(transformedProduct);
        setSnackbarOpen(true);
    }
};

  const increaseQuantity = (product) => {
    setQuantity({ ...quantity, [product.id]: quantity[product.id] + 1 });
    updateQuantity(product, quantity[product.id] + 1);
  };

  const decreaseQuantity = (product) => {
    if (quantity[product.id] > 1) {
      setQuantity({ ...quantity, [product.id]: quantity[product.id] - 1 });
      updateQuantity(product, quantity[product.id] - 1);
    }
  };

  const isInCart = (product) => !!cart.find((item) => item.id === product.id);
// wishlist icon toggled
  useEffect(() => {
    const newWishlistStatus = products?.reduce((acc, product) => {
      const wishlistItem = wishlist?.find(
        (item) => item.product_id === product.id
      );
      if (wishlistItem) {
        return { ...acc, [product.id]: "added" };
      }
      return { ...acc, [product.id]: "not_added" };
    }, {});

    setWishlistStatus(newWishlistStatus);
  }, [wishlist]);

//  Swiper config for slider
  if (isLoading) {
    return (
      <div className="border p-3 relative shadow-xl rounded-md">
      <Swiper
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        slidesPerView={1}
        spaceBetween={30}
        breakpoints={{
          320: { slidesPerView: 1 }, // Show 1 slide in very small screens
          640: { slidesPerView: 2 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
          1440: { slidesPerView: 4 }, 
        }}
        
      >
        {Array(10)
          .fill()
          .map((_, index) => (
            <SwiperSlide key={index} className="w-full h-full">
              <div className="w-full h-full flex justify-center items-center">
                <div className="bg-white p-4 shadow-sm rounded-xl w-full max-w-screen-md m-4 transition-transform transform hover:scale-105">
                  
                  {/* Shimmered Product Image */}
                  <div className="animate-shimmer bg-gradient-to-r from-gray-200 to-gray-400 relative h-52 md:h-64 lg:h-60 w-full mb-4 group rounded-md"></div>
    
                  {/* Shimmered Product Info */}
                  <div className="flex justify-between items-center">
                    <div className="text-left flex-grow">
                      <div className="animate-shimmer bg-gradient-to-r from-gray-200 to-gray-400 h-6 w-3/4 mb-2 rounded"></div>
                      <div className="animate-shimmer bg-gradient-to-r from-gray-200 to-gray-400 h-6 w-3/4 mb-2 rounded"></div>
                      <div className="animate-shimmer bg-gradient-to-r from-gray-200 to-gray-400 h-6 w-1/2 mb-2 rounded"></div>
                    </div>
                    {/* Shimmered Add to Cart Button */}
                    <div className="ml-4 flex flex-col items-center">
                      <div className="animate-shimmer bg-gradient-to-r from-gray-200 to-gray-400 w-10 h-10 rounded-full"></div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
      </Swiper>
      <div className="swiper-button-next z-50 bg-gray-200 p-2 rounded-full absolute top-1/2 right-0 transform -translate-y-1/2 cursor-pointer">
        <FaArrowRight color="black" size={20} />
      </div>
      <div className="swiper-button-prev z-50 bg-gray-200 p-2 rounded-full absolute top-1/2 left-0 transform -translate-y-1/2 cursor-pointer">
        <FaArrowLeft color="black" size={20} />
      </div>
      {/* Since Snackbar is not a visible component at all times, and it depends on state, I didn't add a shimmer for it. */}
    </div>
    
    );
  }

  return (
    
   <>
  
   </>
  );
}

export default ProductsSlider;
